import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import css from '../../css/group/groupScreen.module.scss';
import { Header } from './header';
import { RoomScreen } from './room/roomScreen';
import { RoomList } from './roomList';

export const GroupScreen: React.FC = () => {
    return (
        <BrowserRouter>
            <div className={css.content}>
                <Switch>
                    <Route exact path="/">
                        <Header showMembers={true} />
                        <RoomList />
                    </Route>
                    <Route exact path="/groups/:groupId">
                        <Header showMembers={true} />
                        <RoomList />
                    </Route>
                    <Route exact path="/groups/:groupId/rooms/:roomId">
                        <Header showMembers={false} />
                        <RoomScreen />
                    </Route>
                </Switch>
            </div>
        </BrowserRouter>
    );
};
